import React, {useEffect, useState} from "react"
import globalMasehtot from "./SiumShas/masehtot.json"
import {useLocation, useNavigate} from "react-router-dom";
import 'react-datepicker/dist/react-datepicker.css';
import {collection, doc, getDoc, getDocs, query, where} from "firebase/firestore";
import {db} from "./index";
import Spinner from "./spinner";
import Cookies from 'js-cookie';

const Welcome = () => {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const forceExit = queryParams.get("forceExit");
    const [errorMessage, setErrorMessage] = useState("");
    const [fieldsErrors, setFieldsErrors] = useState({});
    const [phone, setPhone]  = useState('');
    const [email, setEmail]  = useState('');
    const [hasExistsSium, setHasExistsSium] = useState(false);
    const [checkCookies, setCheckCookies] = useState(false);
    const [forgotId, setForgotId] = useState(false);
    const [lomedLogin, setLomedLogin] = useState(false);
    const [lomedId, setLomedId] = useState('');
    const [foundUsers, setFoundUsers] = useState([]);
    const [showUsersModal, setShowUsersModal] = useState(false);
    const [loadingButton, setLoadingButton] = useState(null);
    const [showNewSiumModal, setShowNewSiumModal] = useState(false);
    const navigate = useNavigate();

    const submitExistsSium = event => {
        event.preventDefault();

        if (validateForm()) {
            setLoadingButton('existsSium');
            const emailVal = email ? String(email).trim().toLowerCase() : '';
            const phoneVal = phone ? String(phone).replace(/\D/g, '') : '';

            if (emailVal && phoneVal) {
                const siumimRef = collection(db, "siumim");
                const siumimAherRef = collection(db, "siumimAher");

                const queries = [
                    getDocs(query(siumimRef, where("organizerEmail", "==", emailVal))),
                    getDocs(query(siumimAherRef, where("organizerEmail", "==", emailVal)))
                ];

                Promise.all(queries).then(results => {
                    const matchingMap = new Map(); // key: `${collection}|${id}` -> { id, data, collection }

                    const processSnapshot = (snapshot, collectionName) => {
                        snapshot.forEach((doc) => {
                            const key = `${collectionName}|${doc.id}`;
                            if (matchingMap.has(key)) return;

                            const data = doc.data();
                            const docPhone = String(data.organizerPhone || '').replace(/\D/g, '');

                            if (docPhone === phoneVal) {
                                matchingMap.set(key, { id: doc.id, data, collection: collectionName });
                            }
                        });
                    };

                    processSnapshot(results[0], 'siumim');
                    processSnapshot(results[1], 'siumimAher');

                    const matchingSiumim = Array.from(matchingMap.values());

                    if (matchingSiumim.length === 0) {
                        setLoadingButton(null);
                        displayToastMsg('לא נמצא סיום');
                    } else if (matchingSiumim.length === 1) {
                        const match = matchingSiumim[0];
                        if (match.collection === 'siumimAher') {
                            navigate("/niulSiumAher/" + match.id + "/siumStatus");
                        } else {
                            navigate("/niulSium/" + match.id + "/siumStatus");
                        }
                    } else {
                        navigate("/mySiumim/" + matchingSiumim[0].id);
                    }
                }).catch((err) => {
                    console.error('Error searching siumim:', err);
                    setLoadingButton(null);
                    displayToastMsg('אירעה שגיאה בחיפוש');
                });
            } else {
                setLoadingButton(null);
                displayToastMsg('יש למלא אימייל ופלאפון');
            }
        }
    }

    const submitForgotId = event => {
        event.preventDefault();

        if (validateForm()) {
            setLoadingButton('forgotId');
            const emailVal = email ? String(email).trim().toLowerCase() : '';

            if (!emailVal) {
                setLoadingButton(null);
                displayToastMsg('לא נמצא סיום');
                return;
            }

            const siumimRef = collection(db, "siumim");
            const siumimAherRef = collection(db, "siumimAher");

            const queries = [
                getDocs(query(siumimRef, where("organizerEmail", "==", emailVal))),
                getDocs(query(siumimAherRef, where("organizerEmail", "==", emailVal)))
            ];

            Promise.all(queries).then(results => {
                let found = false;
                const today = new Date();

                const processSnapshot = (snapshot, collectionName) => {
                    snapshot.forEach((doc) => {
                        if (found && false) return; // keep processing to send to all matches (don't stop early)
                        const data = doc.data();

                        const docEmail = (data.organizerEmail || '').toString().trim().toLowerCase();
                        if (!docEmail) return;

                        const endDate = data.endSium && typeof data.endSium.toDate === 'function' ? data.endSium.toDate() : data.endSium;
                        if (endDate && endDate < today) return;

                        try {
                            sendEmail(data, doc.id, collectionName);
                            found = true;
                        } catch (e) {
                            console.error('Send email error for sium', doc.id, e);
                        }
                    });
                };

                processSnapshot(results[0], 'siumim');
                processSnapshot(results[1], 'siumimAher');

                if (!found) {
                    setLoadingButton(null);
                    displayToastMsg('לא נמצא סיום');
                } else {
                    setLoadingButton(null);
                }
            }).catch((err) => {
                console.error('Error searching siumim for forgotId:', err);
                setLoadingButton(null);
                displayToastMsg('אירעה שגיאה בחיפוש');
            });
        }
    }

    const validateForm = () => {
        let newErrors = {};

        if (forgotId) {
            if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                newErrors.email = 'נדרש אימייל תקין';
            }
        } else if (lomedLogin) {
            if (!lomedId.trim()) {
                newErrors.lomedId = 'נדרש מזהה ללומד';
            }
        } else if (hasExistsSium) {
            if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                newErrors.email = 'נדרש אימייל תקין';
            }
            if (!phone.trim()) {
                newErrors.phone = 'נדרש מספר הפלאפון';
            }
        }

        setFieldsErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    function displayToastMsg(msg) {
        setErrorMessage(msg);
        const toastModal = document.getElementById('errorModal');
        const toastBootstrap = window.bootstrap.Toast.getOrCreateInstance(toastModal);
        toastBootstrap.show();
    }

    const handlePhoneChange = (e) => {
        const inputValue = e.target.value;
        const numericValue = inputValue.replace(/\D/g, ''); // Remove non-digit characters
        setPhone(numericValue);
    };

    function handleLomedId() {
        if (validateForm()) {
            setLoadingButton('lomedLogin');
            const lomedIdDigits = lomedId.replace(/\D/g, '');

            const queries = []; // each entry: { promise: Promise<GetDocsSnapshot>, source: 'users'|'usersAher' }
            if (lomedIdDigits) {
                queries.push({ promise: getDocs(query(collection(db, "users"), where("phone", "==", lomedIdDigits))), source: 'users' });
                queries.push({ promise: getDocs(query(collection(db, "usersAher"), where("phone", "==", lomedIdDigits))), source: 'usersAher' });
            }

            if (lomedId.includes('@')) {
                const cleanedEmail = String(lomedId).trim().toLowerCase() || '';
                if (cleanedEmail) {
                    queries.push({
                        promise: getDocs(query(collection(db, "users"), where("email", "==", cleanedEmail))),
                        source: 'users'
                    });
                    queries.push({
                        promise: getDocs(query(collection(db, "usersAher"), where("email", "==", cleanedEmail))),
                        source: 'usersAher'
                    });
                }
            }

            Promise.all(queries.map(q => q.promise)).then(async (snapshots) => {
                const links = [];
                const seenIds = new Set();
                const today = new Date();

                for (let i = 0; i < snapshots.length; i++) {
                    const snapshot = snapshots[i];
                    const source = queries[i].source;

                    for (const userDoc of snapshot.docs) {
                        if (seenIds.has(userDoc.id)) continue;

                        const userData = userDoc.data();
                        if (!userData.siumId) continue;

                        let siumDoc = null;
                        try {
                            if (source === 'users') {
                                siumDoc = await getDoc(doc(db, "siumim", userData.siumId));
                            } else {
                                siumDoc = await getDoc(doc(db, "siumimAher", userData.siumId));
                            }
                        } catch (e) {
                            console.error('Error fetching sium for user', userDoc.id, e);
                            continue;
                        }

                        if (!siumDoc || !siumDoc.exists()) continue;

                        const siumData = siumDoc.data();
                        const endSium = siumData.endSium && typeof siumData.endSium.toDate === 'function' ? siumData.endSium.toDate() : siumData.endSium;

                        // Only include if endDate is in the future or today
                        if (!endSium || endSium >= today) {
                            seenIds.add(userDoc.id);
                            const prefix = source === 'usersAher' ? '/userStatusAher/' :
                                ((siumData.haluka && siumData.haluka === 'dapim') ? '/updateStatusDapim/' : '/updateStatus/');
                            links.push({
                                link: prefix + userDoc.id,
                                siumName: siumData.kehilaName
                            });
                        }
                    }
                }

                if (links.length === 0) {
                    setLoadingButton(null);
                    displayToastMsg('לא נמצא לומד עם הפרטים שהוזנו');
                } else if (links.length === 1) {
                    navigate(links[0].link);
                } else {
                    setLoadingButton(null);
                    setFoundUsers(links);
                    setShowUsersModal(true);
                }
            }).catch(e => {
                console.error("Error finding user: ", e);
                setLoadingButton(null);
                displayToastMsg('אירעה שגיאה בחיפוש הלומד');
            });
        }
    }



    function sendEmail(siumObj, siumId, collectionName = 'siumim') {
        const baseLink = collectionName === 'siumimAher' ? 'https://siumshas.co.il/niulSiumAher/' : 'https://siumshas.co.il/niulSium/';
        var data =
            collectionName === 'siumimAher' ?
            {
                service_id: 'service_ehcnv4y',
                template_id: 'template_ocjfgap',
                user_id: 'S00AQOC3z6jpB3gp_',
                template_params: {
                    'to_name': siumObj.organizerName,
                    'email_to': siumObj.organizerEmail,
                    'kehila_name': siumObj.kehilaName,
                    'nishmat': siumObj.nishmat,
                    'book_name': siumObj.bookName,
                    'sium_link': 'https://siumshas.co.il/niulSiumAher/' + siumId + '/siumStatus',
                    'sium_id': siumId
                }
            } :
            {
            service_id: 'service_ehcnv4y',
            template_id: 'template_ocjfgap',
            user_id: 'S00AQOC3z6jpB3gp_',
            template_params: {
                'to_name': siumObj.organizerName,
                'email_to': siumObj.organizerEmail,
                'kehila_name': siumObj.kehilaName,
                'nishmat': siumObj.nishmat,
                'sium_link': baseLink + siumId + '/siumStatus',
                'sium_id': siumId
                }
            };

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        };
        fetch('https://api.emailjs.com/api/v1.0/email/send', requestOptions)
            .then(() => {
                displayToastMsg('נשלח קישור לאימייל שלכם');
            })
            .catch(error => {
                console.error('Email error:', error);
                displayToastMsg('אירעה שגיאה בשליחת המייל');
            });
    }

    useEffect(() => {
        if (forceExit) {
            setCheckCookies(true);
        } else {
            const siumShasId = Cookies.get('siumShasId');
            if (siumShasId) {
                // First try to find in 'siumim' collection
                const docRef = doc(db, "siumim", siumShasId);
                getDoc(docRef).then(sium => {
                    if (sium.exists()) {
                        navigate("/niulSium/" + siumShasId + "/siumStatus");
                    } else {
                        // If not found in 'siumim', try 'siumimAher' collection
                        const docRefAher = doc(db, "siumimAher", siumShasId);
                        getDoc(docRefAher).then(siumAher => {
                            if (siumAher.exists()) {
                                navigate("/niulSiumAher/" + siumShasId + "/siumStatus");
                            } else {
                                setCheckCookies(true);
                            }
                        }).catch(() => {
                            setCheckCookies(true);
                        });
                    }
                }).catch(() => {
                    setCheckCookies(true);
                });
            } else {
                setCheckCookies(true);
            }
        }
    }, [forceExit, navigate]);

    const ButtonWithSpinner = ({ isLoading, children, ...props }) => (
        <button {...props} disabled={isLoading || props.disabled}>
            {isLoading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            ) : children}
        </button>
    );

    if (globalMasehtot.masehtotSelection && checkCookies) {
        return (
            <div className="welcome-container">
                <div className="header">
                    <div className="header-icon">
                        <svg width="135" height="49" viewBox="0 0 135 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M86.3894 46.9941H85.3384L87.4833 41.3423H84.0193V39.4869H84.9845V40.5594H88.7702L86.3894 46.9941Z" fill="#1F2B70"/>
                            <path d="M82.7686 40.5594V44.2057H81.7605V40.5594H82.7686Z" fill="#1F2B70"/>
                            <path d="M74.643 40.5594H77.5172C79.351 40.5594 80.1017 41.353 80.1017 43.5944V46.9941H77.1096V46.2112H79.0936V43.6159C79.0936 41.9 78.6218 41.3423 77.3456 41.3423H76.6056L75.6189 46.9941H74.6001L75.6189 41.3423H74.643V40.5594Z" fill="#1F2B70"/>
                            <path d="M73.0038 40.5594V46.9941H71.9957V40.5594H73.0038Z" fill="#1F2B70"/>
                            <path d="M65.4352 40.5594H70.465V41.3423H69.6499V46.9941H68.6419V41.3423H65.4352V40.5594Z" fill="#1F2B70"/>
                            <path d="M55.5901 40.5594H58.4643C60.2982 40.5594 61.0489 41.353 61.0489 43.5944V46.9941H58.0568V46.2112H60.0408V43.6159C60.0408 41.9 59.5689 41.3423 58.2927 41.3423H57.5527L56.5661 46.9941H55.5472L56.5661 41.3423H55.5901V40.5594Z" fill="#1F2B70"/>
                            <path d="M48.8315 40.5594H51.8987C53.5502 40.5594 54.2259 41.16 54.2259 43.3049V46.9941H53.2178V43.3156C53.2178 41.7284 52.7888 41.3423 51.6306 41.3423H49.8396V46.9941H48.8315V40.5594Z" fill="#1F2B70"/>
                            <path d="M46.7955 40.5594V46.9941H45.7874V40.5594H46.7955Z" fill="#1F2B70"/>
                            <path d="M42.0379 46.9941H40.9869L43.1318 41.3423H39.6678V39.4869H40.633V40.5594H44.4187L42.0379 46.9941Z" fill="#1F2B70"/>
                            <path d="M33.0906 40.5594H38.4635V44.3023C38.4635 46.2863 37.7343 46.9941 36.0612 46.9941H35.3856V46.2112H35.9111C36.9621 46.2112 37.4662 45.8144 37.4662 44.313V41.3423H33.0906V40.5594ZM33.1549 48.6028V43.2298H34.163V48.6028H33.1549Z" fill="#1F2B70"/>
                            <path d="M27.9071 40.5594V46.2112H28.7758V46.9941H23.3707V46.2112H26.899V41.3423H23.3707V40.5594H27.9071Z" fill="#1F2B70"/>
                            <path d="M16.5361 40.5594H21.909V44.3023C21.909 46.2863 21.1798 46.9941 19.5067 46.9941H18.8311V46.2112H19.3566C20.4076 46.2112 20.9116 45.8144 20.9116 44.313V41.3423H16.5361V40.5594ZM16.6004 48.6028V43.2298H17.6085V48.6028H16.6004Z" fill="#1F2B70"/>
                            <path d="M12.9795 46.9941H11.9285L14.0734 41.3423H10.6094V39.4869H11.5746V40.5594H15.3604L12.9795 46.9941Z" fill="#1F2B70"/>
                            <path d="M9.25981 40.5594V46.9941H8.25171V40.5594H9.25981Z" fill="#1F2B70"/>
                            <path d="M0.484871 40.5594H3.93815C5.58971 40.5594 6.35115 41.2351 6.35115 43.3049V46.9941H5.34305V43.3907C5.34305 41.8142 4.82827 41.3423 3.72366 41.3423H2.40455V46.9941H0.120239V46.2112H1.43935V41.3423H0.484871V40.5594Z" fill="#1F2B70"/>
                            <path d="M78.8004 23.4675C78.2379 23.4675 77.5854 23.1975 77.5854 22.365V19.575C77.5854 19.1025 77.9679 18.8325 78.2829 18.8325C78.3054 19.3275 78.7554 19.575 79.2054 19.575H85.7304C87.6879 19.575 88.6104 20.835 88.6104 22.6575V28.98L87.0354 32.6925L79.1154 32.6475C78.6429 31.5675 77.8554 29.565 77.8779 27.36C77.9004 25.6275 78.8904 24.5475 80.1504 23.4675H78.8004ZM79.9254 28.755H88.4529L88.2954 25.92C88.2054 24.255 87.4629 23.4675 85.8429 23.4675H80.3979C79.0029 24.66 79.0479 26.145 79.9254 28.755Z" fill="#1F2B70"/>
                            <path d="M75.749 20.6325C75.9515 21.7575 75.929 24.1425 74.399 27.2925L74.219 27.2025C75.2315 25.0425 75.1865 23.4675 73.769 23.4675H71.519C70.934 23.4675 70.3265 23.1975 70.3265 22.365V19.575C70.3265 19.1025 70.709 18.8325 70.979 18.8325C71.0465 19.35 71.384 19.575 71.9465 19.575H74.2865C75.1865 19.575 75.614 19.9125 75.749 20.6325Z" fill="#1F2B70"/>
                            <path d="M68.2405 24.165C68.2855 23.7825 68.218 23.4675 67.813 23.4675H64.7755C64.213 23.4675 63.5605 23.1975 63.5605 22.365V19.575C63.5605 19.1025 63.988 18.8325 64.258 18.8325C64.2805 19.35 64.708 19.575 65.1805 19.575H67.5205C68.5555 19.575 68.713 19.9125 68.668 21.06L68.2855 25.5825C68.1505 27.0675 69.343 29.0925 69.163 30.9375C69.118 31.7025 68.938 32.7375 67.408 32.7375L68.2405 24.165Z" fill="#1F2B70"/>
                            <path d="M58.985 19.575C60.92 19.575 61.91 20.79 61.91 22.59V28.89L61.595 32.6475H51.5375V27.6075C51.5375 25.875 53.045 24.3 53.765 23.4675H52.1675C51.65 23.4675 50.9975 23.1975 50.9975 22.365V19.575C50.9975 19.1025 51.4025 18.81 51.65 18.8325C51.695 19.35 52.1225 19.575 52.595 19.575H58.985ZM53.2025 28.755H61.7075L61.595 25.8525C61.5275 24.1875 60.83 23.4675 59.21 23.4675H53.99C53.27 24.2325 53.2025 24.5025 53.2025 25.5375V28.755Z" fill="#1F2B70"/>
                            <path d="M35.6514 23.4675C35.0664 23.4675 34.4139 23.1975 34.4139 22.365V19.575C34.4139 19.1025 34.8414 18.8325 35.1339 18.8325C35.1339 19.3725 35.6064 19.575 36.0789 19.575H43.6614C44.5839 19.575 44.7414 20.0025 44.7414 20.7V23.4675H43.3464V25.8525C43.3464 27.36 44.7864 29.0925 44.7864 30.9375C44.7864 31.7025 44.2239 32.715 43.1664 32.7375V23.4675H35.6514ZM34.5039 32.7375V29.5425C34.5039 27.72 35.1339 26.64 35.6964 26.2575C35.9664 26.0775 36.2364 26.0775 36.3714 26.1225C36.1914 26.4825 35.9664 27.2025 35.9664 27.8775C35.9664 28.89 36.2589 29.97 36.2589 31.3875C36.2589 32.2875 35.7639 32.715 34.5039 32.7375Z" fill="#1F2B70"/>
                            <path d="M24.8145 23.4675C24.297 23.4675 23.6445 23.1975 23.6445 22.365V19.575C23.6445 19.1025 24.0045 18.8325 24.297 18.8325C24.342 19.2825 24.792 19.575 25.2645 19.575H26.7945C27.717 19.575 27.897 20.0925 27.897 20.5425V23.4675H26.547L22.632 28.755H27.582C29.877 28.755 30.192 28.17 30.9795 26.8425C32.2845 24.6375 32.5545 24.4575 32.5545 23.4675H29.6745C29.157 23.4675 28.5045 23.1975 28.5045 22.365V19.575C28.5045 19.1025 28.8645 18.8325 29.157 18.8325C29.202 19.2825 29.652 19.575 30.1245 19.575H31.0695C32.217 19.575 32.712 20.0475 32.712 21.015V23.58C32.712 25.605 31.002 25.5375 31.002 30.105C31.002 32.1975 29.922 32.6475 28.0095 32.6475H21.147V30.8925C21.147 29.6325 19.572 27.2025 19.572 25.9425C19.572 24.975 20.0445 23.85 21.147 23.4675H19.9095C19.347 23.4675 18.717 23.1975 18.717 22.365V19.575C18.717 19.1025 19.122 18.8325 19.392 18.8325C19.4145 19.2825 19.8645 19.575 20.337 19.575H21.9345C22.812 19.575 23.037 20.0925 23.037 20.5425V23.4675H21.9345C21.372 23.4675 20.1345 23.8275 20.1345 25.1325C20.1345 26.64 22.137 27.4725 22.4295 28.7325L26.322 23.4675H24.8145Z" fill="#1F2B70"/>
                            <path d="M13.6264 18C14.4139 18 14.6389 18.3375 14.7289 18.8775C14.8864 19.845 14.6614 21.96 12.4339 23.1975L12.2764 23.04C12.8164 21.9825 12.9064 20.1825 12.4789 18.1125C12.8614 18.0225 13.2439 18 13.6264 18ZM14.9089 23.04C15.4489 21.9825 15.5389 20.1825 15.1114 18.1125C15.4939 18.0225 15.8764 18 16.2589 18C17.0464 18 17.2714 18.3375 17.3614 18.8775C17.5189 19.845 17.2939 21.96 15.0664 23.1975L14.9089 23.04Z" fill="#1F2B70"/>
                            <path d="M1.215 23.4675C0.6525 23.4675 0 23.1975 0 22.365V19.575C0 19.1025 0.3825 18.8325 0.6975 18.8325C0.72 19.3275 1.17 19.575 1.62 19.575H8.145C10.1025 19.575 11.025 20.835 11.025 22.6575V28.98L9.45 32.6925L1.53 32.6475C1.0575 31.5675 0.27 29.565 0.2925 27.36C0.315 25.6275 1.305 24.5475 2.565 23.4675H1.215ZM2.34 28.755H10.8675L10.71 25.92C10.62 24.255 9.8775 23.4675 8.2575 23.4675H2.8125C1.4175 24.66 1.4625 26.145 2.34 28.755Z" fill="#1F2B70"/>
                            <path d="M115.193 10.8004C113.895 10.8004 112.258 10.1232 112.258 8.03513V5.60816C112.258 4.42306 113.161 3.74586 113.895 3.74586C114.008 4.87452 115.136 5.60816 116.321 5.60816H120.159C122.472 5.60816 122.924 6.90612 122.924 8.03478V10.8004H119.538L109.719 38.8377H122.134C127.89 38.8377 128.68 37.3704 130.655 34.0408C133.928 28.5104 134.605 28.0589 134.605 25.5758H127.382C126.084 25.5758 124.447 24.8986 124.447 22.8106V15.8129C124.447 14.6278 125.35 13.9506 126.084 13.9506C126.197 15.0793 127.325 15.8129 128.51 15.8129H130.881C133.759 15.8129 135 16.998 135 19.4246V25.858C135 30.937 130.711 30.7677 130.711 42.2237C130.711 47.472 128.003 48.6006 123.206 48.6006H105.995V44.1988C105.995 41.0386 102.044 34.9438 102.044 31.7835C102.044 29.3569 103.229 26.5352 105.995 25.5758H102.891C101.48 25.5758 99.9 24.8986 99.9 22.8106V15.8129C99.9 14.6278 100.916 13.9506 101.593 13.9506C101.649 15.0793 102.778 15.8129 103.963 15.8129H107.97C110.17 15.8129 110.735 17.1109 110.735 18.2395V25.5758H107.97C106.559 25.5758 103.455 26.4788 103.455 29.7519C103.455 33.533 108.478 35.621 109.211 38.7813L118.974 10.8004H115.193Z" fill="#1F2B70"/>
                            <path d="M124.313 1.33474C124.08 1.24031 123.824 1.21549 123.576 1.26344C123.329 1.31138 123.102 1.42993 122.924 1.60397L121.275 3.20821L118.351 0.363263C118.112 0.130666 117.788 0 117.45 0C117.112 0 116.788 0.130666 116.549 0.363263L113.625 3.20821L111.976 1.60397C111.798 1.43051 111.571 1.31239 111.324 1.26453C111.076 1.21668 110.82 1.24125 110.587 1.33514C110.354 1.42902 110.155 1.58801 110.015 1.79199C109.875 1.99598 109.8 2.2358 109.8 2.48115V9.04823C109.801 9.87057 110.137 10.6589 110.735 11.2404C111.332 11.8219 112.142 12.149 112.987 12.15H121.912C122.758 12.149 123.568 11.8219 124.165 11.2404C124.763 10.6589 125.099 9.87057 125.1 9.04823V2.48115C125.1 2.23578 125.025 1.9959 124.885 1.79185C124.745 1.58779 124.546 1.42871 124.313 1.33474Z" fill="#1F2B70"/>
                        </svg>
                    </div>
                    <div className="header-new-sium">
                        <button type="button" className="btn new-sium-button dark-button" onClick={() => setShowNewSiumModal(true)}>יצירת סיום חדש</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                        <div className="tania-image">
                            <svg width="100%" height="100%" viewBox="0 0 500 692" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M217.782 153.755C199.304 153.755 176.007 144.115 176.007 114.389V79.8385C176.007 62.9672 188.861 53.3266 199.304 53.3266C200.911 69.3944 216.978 79.8385 233.849 79.8385H288.477C321.415 79.8385 327.842 98.3165 327.842 114.384V153.755H279.64L139.856 552.899H316.595C398.537 552.899 409.784 532.01 437.902 484.61C484.496 405.878 494.137 399.45 494.137 364.101H391.307C372.83 364.101 349.532 354.46 349.532 324.735V225.114C349.532 208.243 362.386 198.603 372.83 198.603C374.436 214.67 390.504 225.114 407.374 225.114H441.115C482.086 225.114 499.76 241.986 499.76 276.532V368.118C499.76 440.423 438.705 438.014 438.705 601.102C438.705 675.818 400.144 691.886 331.858 691.886H86.8342V629.221C86.8342 584.231 30.5991 497.465 30.5991 452.475C30.5991 417.929 47.4697 377.759 86.8342 364.101H42.6495C22.5656 364.101 0.0715332 354.46 0.0715332 324.735V225.114C0.0715332 208.243 14.532 198.603 24.1723 198.603C24.9756 214.67 41.0428 225.114 57.9133 225.114H114.952C146.283 225.114 154.316 243.592 154.316 259.66V364.101H114.952C94.8678 364.101 50.6831 376.956 50.6831 423.553C50.6831 477.38 122.182 507.106 132.626 552.095L271.607 153.755H217.782Z" fill="#1F2B70"/>
                                <path d="M347.623 19.0015C344.307 17.6572 340.654 17.3039 337.131 17.9865C333.608 18.669 330.373 20.3567 327.838 22.8344L304.369 45.6725L262.749 5.17146C259.345 1.86018 254.729 0 249.916 0C245.103 0 240.487 1.86018 237.083 5.17146L195.463 45.6725L171.993 22.8344C169.455 20.3649 166.221 18.6833 162.7 18.0021C159.18 17.3209 155.531 17.6707 152.215 19.0072C148.899 20.3438 146.064 22.6071 144.07 25.511C142.075 28.415 141.01 31.8292 141.009 35.322V128.812C141.024 140.519 145.809 151.742 154.316 160.02C162.823 168.298 174.357 172.955 186.387 172.969H313.445C325.475 172.955 337.009 168.298 345.516 160.02C354.022 151.742 358.808 140.519 358.822 128.812V35.322C358.823 31.8289 357.76 28.414 355.766 25.509C353.773 22.604 350.939 20.3394 347.623 19.0015Z" fill="#1F2B70"/>
                                <image className="tania-img" />
                                <image href="/tania.png" x="-150" y="60" width="800" height="700" preserveAspectRatio="xMidYMid slice" />
                                <image href="/arrow.png" x="0" y="470" width="120" height="150" preserveAspectRatio="xMidYMid slice" />
                                <text x="-70" y="570" fontFamily="Mugrabi v2 AAA" fontSize="15" width="50" height="50" fill="#3A499E">
                                    <tspan x="-60" dy="1.2em">דבריו של</tspan>
                                    <tspan x="-70" dy="1.2em">בעל התניא</tspan>
                                    <tspan x="-85" dy="1.2em">באגרות קודש</tspan>
                                </text>
                            </svg>
                        </div>
                    </div>
                    <div className="col-lg-6 welcome-text-container">
                        <div>
                            <h3>ברוכים הבאים למערכת</h3>
                            <h1>סיום הש”ס</h1>
                            <h2>ניהול לימוד תורני מחולק בקלות</h2>
                        </div>
                        <div className="exists-sium">
                            <p className="welcome-text">
                                ניהול של לימוד תורני מחולק עם מספר משתתפים גדול יכול להוות אתגר לא קטן.
                                אתר <span className="welcome-text-bold">'סיום הש"ס'</span> הוקם כדי לסייע לנהל בקלות וביעילות סיומים
                                תורניים מחולקים עבור קבוצות, קהילות וארגונים.
                                בין הספרים שתוכלו לנהל באתר:
                                <span className="welcome-text-bold"> ש"ס גמרא, ש"ס משניות, משנה ברורה, שו"ע, פרשן על התורה, נביאים כתובים ועוד.</span>
                            </p>
                            <div className="input-container full-width exists-sium-btn-container">
                                <button type="button" className="btn new-sium-button example-sium dark-button" onClick={() => window.open("/displaySium/E7MzanplueEjry7ba3Tb")}>סיום ש"ס לדוגמא</button>
                            </div>
                            <p className="welcome-text">
                                <span>באמצעות האתר תוכל לנהל את חלוקת הספרים ומעקב אחר מצב הלמידה בכל רגע נתון. המערכת יוצרת לכל לומד קישור פרטי לעדכון מצב הלמידה שלו ומאפשרת שיתוף מהיר.</span>
                                <span className="welcome-text-bold"> השימוש במערכת ללא עלות וללא מטרות רווח, אלא רק להגדיל תורה ולהאדירה!</span>
                            </p>
                        </div>
                        {!hasExistsSium && !forgotId && !lomedLogin && <div className="welcome-buttons">
                            <button type="button" className="btn new-sium-button dark-button" onClick={() => setShowNewSiumModal(true)}>יצירת סיום חדש</button>
                            <button type="button" className="btn new-sium-button" onClick={() => setHasExistsSium(true)}>כניסה לסיום שלי</button>
                        </div>}
                        {!hasExistsSium && !forgotId && !lomedLogin && <div className="welcome-buttons">
                            <button type="button" className="btn new-sium-button dark-button" onClick={() => setLomedLogin(true)}>כניסה ללומדים</button>
                        </div>}
                        {hasExistsSium && !forgotId && !lomedLogin && <div className="exists-sium">
                            <form onSubmit={submitExistsSium}>
                                <div className="input-row">
                                    <div className="input-container">
                                        <input
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            className="input"
                                            placeholder="אימייל"
                                            name="usrEmail"
                                        />
                                        {fieldsErrors.email && <div className="fields-error-message">{fieldsErrors.email}</div>}
                                    </div>
                                    <div className="input-container">
                                        <input
                                            type="tel"
                                            value={phone}
                                            onChange={handlePhoneChange}
                                            className="input"
                                            placeholder="פלאפון"
                                            pattern="[0-9]*"
                                            name="usrPhone"
                                        />
                                        {fieldsErrors.phone && <div className="fields-error-message">{fieldsErrors.phone}</div>}
                                    </div>
                                </div>
                                <div className="input-container full-width exists-sium-btn-container">
                                    <ButtonWithSpinner
                                        type="submit"
                                        className="btn new-sium-button exists-sium-btn dark-button"
                                        isLoading={loadingButton === 'existsSium'}
                                    >
                                        כניסה לסיום
                                    </ButtonWithSpinner>
                                </div>
                                <div className="input-container full-width exists-sium-btn-container">
                                    <button className="btn new-sium-button forgot-btn" onClick={() => {setForgotId(true); delete fieldsErrors.phone}}>עדין לא מצליח?</button>
                                </div>
                            </form>
                        </div>}
                        {forgotId && !lomedLogin && <div className="exists-sium">
                            <form onSubmit={submitForgotId}>
                                <div className="input-row">
                                    <div className="input-container">
                                        <input
                                            type="email"
                                            value={email}
                                            className="input"
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="אימייל"
                                            name="usrEmail"
                                        />
                                        {fieldsErrors.email && <div className="fields-error-message">{fieldsErrors.email}</div>}
                                    </div>
                                    <div className="input-container">
                                        <ButtonWithSpinner
                                            type="submit"
                                            className="btn new-sium-button send-forgot-id dark-button"
                                            isLoading={loadingButton === 'forgotId'}
                                        >
                                            שלח לי לינק כניסה
                                        </ButtonWithSpinner>
                                    </div>
                                </div>
                            </form>
                        </div>}
                        {lomedLogin && !forgotId && <div className="exists-sium">
                            <div className="input-row">
                                <div className="input-container">
                                    <input
                                        type="text"
                                        value={lomedId}
                                        className="input"
                                        onChange={(e) => setLomedId(e.target.value)}
                                        placeholder="אימייל או פלאפון"
                                        name="lomedId"
                                    />
                                    {fieldsErrors.lomedId && <div className="fields-error-message">{fieldsErrors.lomedId}</div>}
                                </div>
                                <div className="input-container">
                                    <ButtonWithSpinner
                                        className="btn new-sium-button send-forgot-id dark-button"
                                        onClick={() => handleLomedId()}
                                        isLoading={loadingButton === 'lomedLogin'}
                                    >
                                        כניסה ללומד
                                    </ButtonWithSpinner>
                                </div>
                            </div>
                        </div>}
                    </div>

                    {showUsersModal && (
                        <div className="modal show d-block sium-main-container" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
                            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">בחר את הסיום שלך</h5>
                                        <button type="button" className="btn-close" onClick={() => setShowUsersModal(false)}></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="list-group">
                                            {foundUsers.map((user, index) => (
                                                <button
                                                    key={index}
                                                    type="button"
                                                    className="list-group-item list-group-item-action"
                                                    onClick={() => navigate(user.link)}
                                                >
                                                    <div><strong>{user.siumName}</strong></div>
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* New Sium Options Modal */}
                    {showNewSiumModal && (
                        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', direction: 'rtl' }}>
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">בחר את הסיום שלך</h5>
                                        <button type="button" className="btn-close" onClick={() => setShowNewSiumModal(false)}></button>
                                    </div>
                                    <div className="modal-body new-sium-options-modal">
                                        {/* Main option - Shas Gemara */}
                                        <button
                                            className="sium-option-btn main-option"
                                            onClick={() => navigate('/newSium')}
                                        >
                                            <div className="sium-option-icon">
                                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                                                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                                                </svg>
                                            </div>
                                            <span className="sium-option-text">סיום ש"ס גמרא</span>
                                        </button>

                                        {/* Secondary options */}
                                        <div className="sium-options-secondary">
                                            <button
                                                className="sium-option-btn secondary-option"
                                                onClick={() => navigate('/newSiumAher?mipuiId=2rN4gXL26hGI6aGhuTPe')}
                                            >
                                                <div className="sium-option-icon-small">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                                                        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                                                    </svg>
                                                </div>
                                                <span className="sium-option-text-small">משנה תורה לרמב"ם</span>
                                            </button>

                                            <button
                                                className="sium-option-btn secondary-option"
                                                onClick={() => navigate('/newSiumAher?mipuiId=2RaGfiFR3lrsjWaqkRCQ')}
                                            >
                                                <div className="sium-option-icon-small">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                                                        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                                                    </svg>
                                                </div>
                                                <span className="sium-option-text-small">משנה ברורה</span>
                                            </button>

                                            <button
                                                className="sium-option-btn secondary-option"
                                                onClick={() => navigate('/newSiumAher?mipuiId=8yrjgmKjzFQ9Q2z0Qlpi')}
                                            >
                                                <div className="sium-option-icon-small">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                                                        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                                                    </svg>
                                                </div>
                                                <span className="sium-option-text-small">נביאים כתובים</span>
                                            </button>

                                            <button
                                                className="sium-option-btn secondary-option"
                                                onClick={() => navigate('/newSiumAher?mipuiId=9tS5EnuUNpVJSacnigBB')}
                                            >
                                                <div className="sium-option-icon-small">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                                                        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                                                    </svg>
                                                </div>
                                                <span className="sium-option-text-small">שולחן ערוך</span>
                                            </button>

                                            <button
                                                className="sium-option-btn secondary-option"
                                                onClick={() => navigate('/newSiumAher?mipuiId=CefBqHOX8jgds4shamBN')}
                                            >
                                                <div className="sium-option-icon-small">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                                                        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                                                    </svg>
                                                </div>
                                                <span className="sium-option-text-small">ש"ס משניות</span>
                                            </button>

                                            <button
                                                className="sium-option-btn secondary-option"
                                                onClick={() => navigate('/newSiumAher?mipuiId=qaG7gfXyuoxWhOm3EXWq')}
                                            >
                                                <div className="sium-option-icon-small">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                                                        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                                                    </svg>
                                                </div>
                                                <span className="sium-option-text-small">רמב"ן על התורה</span>
                                            </button>

                                            <button
                                                className="sium-option-btn secondary-option"
                                                onClick={() => navigate('/newSiumAher?mipuiId=aFUAaa6dMyoVRxyY6RmF')}
                                            >
                                                <div className="sium-option-icon-small">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                                                        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                                                    </svg>
                                                </div>
                                                <span className="sium-option-text-small">ספר תהילים</span>
                                            </button>

                                            <button
                                                className="sium-option-btn secondary-option"
                                                onClick={() => navigate('/newSiumAher?mipuiId=h7ijjKWyvikU6Kf7MIun')}
                                            >
                                                <div className="sium-option-icon-small">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                                                        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                                                    </svg>
                                                </div>
                                                <span className="sium-option-text-small">ליקוטי מוהר"ן</span>
                                            </button>

                                            <button
                                                className="sium-option-btn secondary-option"
                                                onClick={() => navigate('/newSiumAher?mipuiId=aCdIT9ZJiGekYfsi7RSh')}
                                            >
                                                <div className="sium-option-icon-small">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                                                        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                                                    </svg>
                                                </div>
                                                <span className="sium-option-text-small">ספר התניא</span>
                                            </button>
                                        </div>

                                        {/* Additional main option - Other */}
                                        <button
                                            className="sium-option-btn main-option"
                                            onClick={() => navigate('/newSiumAher')}
                                        >
                                            <div className="sium-option-icon">
                                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                                                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                                                </svg>
                                            </div>
                                            <span className="sium-option-text">עוד</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="toast-container position-fixed top-0 start-50 translate-middle-x">
                        <div id="errorModal" className="toast" role="alert" aria-live="assertive"
                             aria-atomic="true" data-bs-autohide="true" data-bs-delay="3000">
                            <button type="button" className="btn-close me-2 m-auto" data-bs-dismiss="toast"
                                    aria-label="Close"></button>
                            <div className="toast-body">
                                {errorMessage}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else {
        return (<Spinner/>);
    }

}

export default Welcome;
